export enum SortingTitleEnum {
  Name = 'Filename',
  Size = 'Größe',
  CreatedOn = 'Erstellt am',
  CreatedBy = 'Erstellt von'
}
